// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

//ENUMS
// eslint-disable-next-line no-unused-vars
import { ProjectSort } from "@/enums/Project/ProjectSort.js";
// eslint-disable-next-line no-unused-vars
import { ProjectType } from "@/enums/Project/ProjectType.js";

// ## Project Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, sortBy: ProjectSort, sortOrder: 'ASC' | 'DESC', type: ProjectType, isLocked: boolean, userId: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Project.GetAll(option));

  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Project Create
/**
 *
 * @param {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": ProjectRole}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Project.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Project.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project Update
/**
 *
 * @param  {{ "name": "string", "surname": "string", "email": "user@example.com", "phoneNo": "string", "password": "string", "role": ProjectRole}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Project.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Project.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project UpdateLockStatus
/**
 *
 * @param {{ params: { id: string }, query: object}} option
 * @param {{isLocked: boolean}} form
 *
 * @returns
 */
export const UpdateLockStatus = async (option, form) => {
  const response = await $api.put(
    Endpoints.Project.UpdateLockStatus(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Project GetProjectLogs
/**
 *
 * @param {{ query: { id: string, limit: number, page: number }, params: object}} option
 *
 * @returns
 */
export const GetProjectLogs = async (option) => {
  const response = await $api.get(Endpoints.Project.GetProjectLogs(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Project ReactivateProject
/**
 *
 * @param {{ id: number }} form
 *
 * @returns
 */
export const ReactivateProject = async (form) => {
  const response = await $api.post(Endpoints.Project.ReactivateProject(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  UpdateLockStatus,
  GetProjectLogs,
  ReactivateProject,
};
